module.exports = __webpack_public_path__ + "static/media/cq_allegato.715fc2a4.svg";